export default {
  SOME_AWESOME_AFFIRM: `SOME_AWESOME_AFFIRM`,
  SOME_AWESOME_HEADER: `SOME_AWESOME_HEADER`,
  SOME_AWESOME_PARAGRAPH: `SOME_AWESOME_PARAGRAPH`,
  STEPS_1: `STEPS_1`,
  STEPS_2: `STEPS_2`,
};
